import { PaymentRequestPassive } from 'lib/types/models';
import { Dispatch } from 'redux';

import { requestHandler } from '../../api';

export async function getPaymentRequestPassive(
  dispatch: Dispatch,
  id: number,
): Promise<PaymentRequestPassive | undefined> {
  const response = await requestHandler({
    method: 'get',
    url: `internal/paymentRequestPassive/${id}`,
    dispatch,
  });
  if (response) return response.data;
}

export async function postPayoutsForPaymentRequestPassive(
  dispatch: Dispatch,
  id: number,
  data: {
    payments: any;
  },
) {
  const response = await requestHandler({
    method: 'post',
    url: `internal/paymentRequestPassive/${id}/payouts`,
    data,
    dispatch,
  });
  if (response) return response.data;
}

export const getAllPaymentRequestPassives = async (
  dispatch: Dispatch,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/paymentRequestPassive?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getPaymentRequestPassiveReversePreview = async (
  dispatch: Dispatch,
  id: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/paymentRequestPassive/${id}/reverse/preview`,
    dispatch,
  });
  if (response) return response.data;
};

export const reversePaymentRequestPassive = async (
  dispatch: Dispatch,
  id: string,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/paymentRequestPassive/${id}/reverse`,
    dispatch,
  });
  if (response) return response.data;
};

export const updatePaymentRequestPassiveObservation = async (
  dispatch: Dispatch,
  id: number,
  observation: string,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/paymentRequestPassive/${id}/observation`,
    data: { observation },
  });
  if (response) return response.data;
};
